import { PostHogProvider, usePostHog } from 'posthog-js/react';
import { ReactElement, useEffect } from 'react';

import { useAuthUser } from 'auth/hooks';
import { objectKeysCamelToSnakeCase } from 'core/utils';

export const PostHog = ({ children }: { children: ReactElement }) => {
  const { user } = useAuthUser();
  const postHog = usePostHog();

  useEffect(() => {
    if (process.env.REACT_APP_POSTHOG_ENABLED && user && postHog) {
      postHog.identify(
        String(user.id),
        objectKeysCamelToSnakeCase({
          id: user.id,
          email: user.email,
          name: `${user.firstName} ${user.lastName}`.trim(),
          companyId: user.companyId,
          companyName: user.companyName,
        })
      );

      postHog.register(
        objectKeysCamelToSnakeCase({
          instanceUrl: window.location.hostname,
        })
      );
    }
  }, [user, postHog]);

  if (!process.env.REACT_APP_POSTHOG_ENABLED) {
    return children;
  }

  const postHogOptions = {
    api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
    // Monitor event volume and Bugsnag overlap — disable if noisy or quota-heavy.
    capture_exceptions: true,
    session_recording: {
      maskAllInputs: false,
      maskInputOptions: { password: true },
    },
  };

  return (
    <PostHogProvider apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY} options={postHogOptions}>
      {children}
    </PostHogProvider>
  );
};
